import { useSelector } from 'react-redux';
import { CompanyPlanLevel, CompanyPlanStatus } from '../enum/CompanyPlanLevelEnum';

const useCanUseOrderPublicReceipt = (storeId: string): { canUseOrderPublicReceipt: boolean } => {
  const { company } = useSelector((state: any) => state.user);
  const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
    company?.planStatus
  );
  const isStandardOrPremium = [CompanyPlanLevel.STANDARD, CompanyPlanLevel.PREMIUM].includes(
    company.planLevel
  );
  return {
    canUseOrderPublicReceipt: isStandardOrPremium && !isInGraceOrSuspended
  };
};

export default useCanUseOrderPublicReceipt;
